// Copyright (c) 2026 Joshua S. Plaza. All rights reserved.

import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageWrapper from '../components/PageWrapper';

const PublicLayout = () => (
  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <PublicNavbar />
    <Box component="main" sx={{ flexGrow: 1 }}>
      <PageWrapper>
        <Outlet />
      </PageWrapper>
    </Box>
    <Footer variant="public" />
    <BackToTop />
  </Box>
);

export default PublicLayout;
